module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Murphy T. J.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("T.J. Murphy")]), _vm._v(" is a veteran journalist, endurance athlete, CrossFitter, and former editorial director of Triathlete, Inside Triathlon, and Competitor magazines. He is author of Triathlete Magazine's Guide to Finishing Your First Triathlon and contributor to Start to Finish: 24 Weeks to an Endurance Triathlon. His writing has also appeared in Outside magazine and Runner's World. He is a five-time Ironman finisher and a 2:38 marathoner.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ePbmbC/images/cover.jpg?1705842393298",
      "alt": "This image is the cover for the book Inside the Box"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Inside the Box\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In Inside the Box, veteran journalist and marathoner T.J. Murphy goes all in to expose the gritty, high-intensity sport of CrossFit®. Murphy faced a future with a permanent limp from one too many marathons. Desperate to reclaim his fitness and strength, the 47-year-old signed up for his first CrossFit® workout with nothing to lose. Anaerobically blasted by each workout of the day, Murphy discovered a sweat-soaked fitness revolution that’s transforming bodies and lives. CrossFit is the sport of fitness, a radical new approach to exercise that is turning the traditional gym workout upside down. Every day at thousands of CrossFit gyms across America, fitness seekers of all shapes and sizes flex their inner athlete by racing to finish fast-paced workouts. Each workout mixes weight lifting and gymnastics into an explosively effective and addictive new way to lose weight and carve out a new physique. Inside the Box is Murphy’s journey through CrossFit. From staggering newcomer to evangelist, Murphy finds out how it feels, why it’s so popular, whether it can fix his broken body.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    VeloPress Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0